var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.293,
    height: 26.992,
    viewBox: "0 0 24.293 26.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Bag",
    "data-name": "Iconly/Bold/Bag",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bag",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M12.153,0a6.737,6.737,0,0,1,6.741,6.443h-.035a.677.677,0,0,1-.059.3h.211c1.642,0,3.362,1.138,4.052,3.887l.075.324,1.038,8.36c.747,5.332-2.171,7.575-6.15,7.67l-.267,0H6.571c-4.044,0-7.161-1.474-6.476-7.31l.047-.363,1.05-8.36C1.709,8,3.446,6.832,5.121,6.752l.186,0h.106a.876.876,0,0,1,0-.3A6.737,6.737,0,0,1,12.153,0ZM8.229,11.241a1.228,1.228,0,1,0,1.193,1.228h0l-.009-.154A1.205,1.205,0,0,0,8.229,11.241Zm7.813,0a1.228,1.228,0,1,0,1.193,1.228A1.211,1.211,0,0,0,16.041,11.241ZM12.1,1.758A4.694,4.694,0,0,0,7.4,6.443a.876.876,0,0,1,0,.3h9.463a.876.876,0,0,1-.059-.3A4.694,4.694,0,0,0,12.1,1.758Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOrders);
export default __webpack_public_path__ + "static/media/user_orders.3687cac4965056085ea71ab4bf1152dd.svg";
export { ForwardRef as ReactComponent };